module.exports = __webpack_public_path__ + "static/media/Hero_Image_Tablet.3af19ba1.jpg";